import { render, staticRenderFns } from "./Fee.vue?vue&type=template&id=007b0540&scoped=true"
import script from "./Fee.vue?vue&type=script&lang=js"
export * from "./Fee.vue?vue&type=script&lang=js"
import style0 from "./Fee.vue?vue&type=style&index=0&id=007b0540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b0540",
  null
  
)

export default component.exports